module.exports = __webpack_public_path__ + "static/img/fa_data_1.57e8268.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/pc/fa/fa_data_1.jpg
// module id = 165
// module chunks = 0